<template>
	<GlassCard class="p-2">
		<h2 class="p-2">Meal Type Rating Report</h2>
		<input
			type="month"
			v-model="selectedMonth"
			@change="fetchReportData"
			v-if="isOnline" />
		<canvas ref="canvas"></canvas>
	</GlassCard>
</template>

<script setup>
	import { ref, watch, onMounted, onBeforeMount, onBeforeUnmount } from "vue"
	import GlassCard from "./GlassCard.vue"
	import Chart from "chart.js/auto"
	import moment from "moment-timezone"
	// import { useTokenStore } from "@/stores/token"
	// import { hasTokenIssue, handleTokenIssue } from "@/utils/tokenIssue"
	import { fetchWithAuth } from "@/utils/api-client"
	// import { lastMealUpdated, lastMealDeleted } from "@/utils/mealBus"
	import EventBus from "@/utils/eventBus"
	import { isOnline } from "@/utils/networkBus"

	const selectedMonth = ref(moment().format("YYYY-MM"))
	const reportData = ref([])
	const canvas = ref(null)
	// const tokenStore = useTokenStore()

	let myChart = null

	async function fetchReportData(month) {
		if (typeof month === "string") {
			const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
			const [year, monthPart] = month.split("-")
			const response = await fetchWithAuth(
				`/api/report/meal-type-ratings?year=${year}&month=${monthPart}`,
				{
					method: "GET",
					headers: {
						"User-Timezone": tz,
						// Authorization: `Bearer ${tokenStore.token}`,
					},
				}
			)

			// if (hasTokenIssue(response)) {
			// 	handleTokenIssue(response)
			// } else {
			const data = await response.json()
			reportData.value = data

			if (myChart) {
				myChart.destroy()
			}

			// Process data for the chart
			const mealTypes = [...new Set(data.map((item) => item.meal_type))]
			const dayNums = [...new Set(data.map((item) => item.day))].sort(
				(a, b) => a - b
			)

			// const labels = dayNums.map((dayNum) => {
			// 	return dayNum
			// 	// const date = moment
			// 	// 	.unix(dayNum * 86400)
			// 	// 	.tz(tz)
			// 	// 	.format("YYYY-MM-DD")
			// 	// return date
			// })

			const datasets = mealTypes.map((mealType) => {
				const dataPoints = dayNums.map((dayNum) => {
					const item = data.find(
						(d) => d.day === dayNum && d.meal_type === mealType
					)
					return item ? item.rating_sum : 0
				})

				const color = getRandomColor()

				return {
					label: mealType,
					data: dataPoints,
					backgroundColor: color,
					borderColor: color,
					fill: false,
				}
			})

			myChart = new Chart(canvas.value, {
				type: "line",
				data: {
					labels: dayNums,
					datasets: datasets,
				},
				options: {
					scales: {
						y: {
							beginAtZero: false,
							ticks: {
								color: "white",
							},
						},
						x: {
							ticks: {
								color: "white",
							},
						},
					},
					plugins: {
						legend: {
							labels: {
								color: "white",
							},
						},
					},
					responsive: true,
				},
			})
			// }
		}
	}

	function getRandomColor() {
		const r = Math.floor(Math.random() * 200) + 50
		const g = Math.floor(Math.random() * 200) + 50
		const b = Math.floor(Math.random() * 200) + 50
		return `rgba(${r}, ${g}, ${b}, 0.7)`
	}

	onMounted(() => {
		fetchReportData(selectedMonth.value)
	})

	watch(selectedMonth, (newMonth) => {
		fetchReportData(newMonth)
	})

	// watch(lastMealUpdated, () => {
	// 	fetchReportData(selectedMonth.value)
	// })

	// watch(lastMealDeleted, () => {
	// 	fetchReportData(selectedMonth.value)
	// })

	let offMealUpdated = null
	let offMealDeleted = null

	onBeforeMount(() => {
		offMealUpdated = EventBus.on("meal-updated", () => {
			fetchReportData(selectedMonth.value)
		})

		offMealDeleted = EventBus.on("meal-deleted", () => {
			fetchReportData(selectedMonth.value)
		})
	})

	onBeforeUnmount(() => {
		if (offMealUpdated) offMealUpdated()
		if (offMealDeleted) offMealDeleted()
	})
</script>
